<div class="content" *ngIf="isVisible">
  <div class="label">
    <mat-icon>information</mat-icon>
    {{hint}}
  </div>
  <div class="dismissButton" (click)="hideAndDismiss()">
    <mat-icon>done</mat-icon>
  </div>
</div>
